// Testimonials data — extracted from Doctoralia (real verified reviews)
export const TESTIMONIALS = {
  total: 75,
  average_rating: 5.0,
  source: "Doctoralia",
  source_url:
    "https://www.doctoralia.com.br/nivalda-purificacao-de-jesus/psicologo-sexologo/santos#profile-reviews",
  items: [
    {
      id: "t1",
      initials: "L",
      name: "Liliane",
      rating: 5,
      date: "26 de setembro de 2025",
      service: "Consulta Psicologia",
      text: "A psicóloga Nivalda é uma profissional que transmite acolhimento em cada gesto. Ela sabe ouvir com atenção e carinho, sem pressa, fazendo com que cada pessoa se sinta importante e respeitada. Sua empatia vai além das palavras — está no olhar, na forma de compreender as dores.",
    },
    {
      id: "t2",
      initials: "LR",
      name: "Lucas Ribas",
      rating: 5,
      date: "10 de abril de 2025",
      service: "Aconselhamento Psicológico",
      text: "A Dra. Nivalda, além de uma excelente profissional, é uma pessoa maravilhosa. Eu só tenho a agradecer por tudo o que ela tem me ajudado nas épocas mais difíceis da minha vida.",
    },
    {
      id: "t3",
      initials: "MC",
      name: "Mais do Carmo",
      rating: 5,
      date: "8 de janeiro de 2026",
      service: "Consulta Psicologia",
      text: "A Dra. Nivalda é uma profissional incrível, sou grata por toda orientação e pelo refrigério recebido pelo excelente atendimento. Dedicação e profissionalismo definem minha opinião.",
    },
    {
      id: "t4",
      initials: "TH",
      name: "TH",
      rating: 5,
      date: "16 de dezembro de 2025",
      service: "Terapia de Casal",
      text: "Profissional maravilhosa, visão e entendimento prático e rápido. Linguagem de fácil entendimento com explicações e dados claros. Super recomendo!",
    },
    {
      id: "t5",
      initials: "FCD",
      name: "FCD",
      rating: 5,
      date: "3 de dezembro de 2025",
      service: "Avaliação Neuropsicológica",
      text: "A consulta foi extremamente produtiva. A profissional é pontual, empática, demonstra fluidez e naturalidade na condução da sessão.",
    },
    {
      id: "t6",
      initials: "SD",
      name: "Solange Diniz",
      rating: 5,
      date: "12 de novembro de 2025",
      service: "Consulta Psicologia",
      text: "Profissional com muita experiência, atenciosa, gentil e que se comunica de forma simples e clara.",
    },
    {
      id: "t7",
      initials: "J.C",
      name: "J. C.",
      rating: 5,
      date: "16 de fevereiro de 2026",
      service: "Avaliação Neuropsicológica",
      text: "Muito boa, me ajudou a resolver meu problema. Melhor psicóloga que eu já fui!",
    },
    {
      id: "t8",
      initials: "V.P.",
      name: "V. P.",
      rating: 5,
      date: "26 de fevereiro de 2026",
      service: "Avaliação Neuropsicológica",
      text: "Avaliação muito bem feita e direta, consegui tirar muitas dúvidas.",
    },
    {
      id: "t9",
      initials: "I",
      name: "Isabel",
      rating: 5,
      date: "22 de agosto de 2025",
      service: "Primeira consulta psicologia",
      text: "Profissional extremamente atenciosa. Primeira consulta e me senti totalmente confortável!",
    },
  ],
};
